import React from "react";

export const infoBoxDescriptions = {
  tax_loss_box: {
    text: (
      <span>
        The world is losing over $472 billion (USD) in tax a year to international tax abuse. Of the $472 billion, nearly $301 billion is lost to multinational
        corporations shifting profit into tax havens in order to underreport how much profit they actually made in the countries where they do business and
        consequently pay less tax than they should. The remaining $171 billion is lost to wealthy individuals hiding undeclared assets and incomes offshore,
        beyond the reach of the law. Find more information <a href="https://www.taxjustice.net/sotj2023">here</a>
      </span>
    ),
  },
  ranking_box: {
    text: (
      <span>
        The <a href="https://fsi.taxjustice.net/en/">Financial Secrecy Index</a> and <a href="https://corporatetaxhavenindex.org/">Corporate Tax Haven Index</a>{" "}
        rank jurisdictions according to how much global financial secrecy they enable and global corporate tax abuse they enable, respectively.
      </span>
    ),
  },
  social_impact_box: {
    text: (
      <span>
        Countries’ public health expenditure is calculated in the report based on the World Health Organisation’s Domestic General Government Health Expenditure
        as percentage of Gross Domestic Product. The latter is based on World Bank data, and for countries for which this data is not available, UN data and, if
        needed, US Central Intelligence Agency data is used.
      </span>
    ),
  },
  harm_box: {
    text: (
      <span>
        Quantification of a country's impact in other countries through its facilitation of both international corporate tax abuse and private tax evasion.
        Higher income countries are responsible for 99.4 per cent of countries’ tax losses, costing countries around the world over $469 billion in lost tax
        every year while lower income countries are responsible for just 0.6 per cent, costing countries over $2.8 billion in lost tax every year.
      </span>
    ),
  },
  // vulnerability_box: {
  //   text: (
  //     <span>
  //       Illicit financial flows are transfers of money from one country to another that are forbidden by law, rules or custom. By enabling money laundering and
  //       corruption and by reducing government funding available in a country, illicit financial flows damage economies, societies and the governance of
  //       countries around the globe. Here, we measure the vulnerability of each country to various channels of illicit financial flows. We take the average of
  //       the last five years and use only economic channels with good information (information on at least 30 partner countries). Please scroll down this page
  //       for a more detailed breakdown of the components of illicit financial flows.
  //     </span>
  //   ),
  // },
  // trading_box: {
  //   text: (
  //     <span>
  //       Illicit financial flows are transfers of money from one country to another that are forbidden by law, rules or custom. By enabling money laundering and
  //       corruption and by reducing government funding available in a country, illicit financial flows damage economies, societies and the governance of
  //       countries around the globe. Here, we measure the vulnerability of each country to various channels of illicit financial flows. We show the trading
  //       partners creating the highest vulnerability to the channel mentioned in the adjacent left box. Please scroll down this page for a more detailed
  //       breakdown of the components of illicit financial flows.
  //     </span>
  //   ),
  // },
};

export const summaryBoxes = Object.keys(infoBoxDescriptions);
